import React, { useRef, useState } from "react";
import FolderDetailSearchForm from "./FolderDetailSearchForm";
import Modal from "@/common/elements/Modal";
import styled from "styled-components";
import FolderFullDetails from "../BookingsDetails/JacketDetails/FolderFullDetails";
import FolderDetailSearchActions from "./FolderDetailSearchActions";
import Button from "@/common/elements/Button";
import {
  isEmptyObject,
  isNonEmptyVariable,
  objectToArray,
} from "@/util/common_function";

const StyledActions = styled.div`
  position: sticky;
  top: 0px;
  background: #fff;
  padding: 0px 15px 10px 15px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  z-index: 9999;
`;

const FolderDetailSearchModal = ({
  show,
  onHide,
  onCloseClick,
  onSaveClick,
}) => {
  const searchFormRef = useRef();
  // Local state to hold the currently selected folder from the search table.
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [isDisabledCurrentJacket, setisDisabledCurrentJacket] = useState(true);

  const handleModalHide = () => {
    if (onCloseClick) onCloseClick();
    if (onHide) onHide();
    setSelectedFolder(null);
  };

  // Call Formik's submit method via the ref.
  const handleSearch = () => {
    if (searchFormRef.current) {
      searchFormRef.current.handleSubmit();
    }
  };

  // Call Formik's reset method via the ref.
  const handleReset = () => {
    if (searchFormRef.current) {
      searchFormRef.current.resetForm();
      setSelectedFolder(null);
    }

    setisDisabledCurrentJacket(() => true);
  };

  const onCreateNewJacket = () => {
    const filter = objectToArray(searchFormRef.current, "filterKey", "value");

    if (isNonEmptyVariable(filter) && filter?.length) {
      const values = filter?.find((f) => f?.filterKey === "values")?.value;
      if (isNonEmptyVariable(values) && !isEmptyObject(values)) {
        if (onSaveClick) onSaveClick(values);
        if (onCloseClick) onCloseClick();
        if (onHide) onHide();
      } else {
        alert("Please search data first");
      }
    }
  };

  // If so, pass the data upward via onSaveClick.
  const handleSelectCurrentJacket = () => {
    if (!selectedFolder) {
      alert("Please select a folder from the list first.");
      return;
    }
    if (onSaveClick) onSaveClick(selectedFolder);
  };

  // Callback to be passed to FolderFullDetails.
  // It receives the folder data when a row is clicked.
  const handleFolderSelected = (folder) => {
    setSelectedFolder(folder);
    if (isNonEmptyVariable(folder)) {
      setisDisabledCurrentJacket(() => false);
    }
  };

  return (
    <Modal
      designPattern="ant"
      show={show}
      header="Search for Folder"
      size="xxl"
      width="85%"
      onHide={handleModalHide}
      className="unstyle-padding"
      footerActions={[
        <Button type="secondary" color="secondary" onClick={handleModalHide}>
          Close
        </Button>,
      ]}
    >
      <StyledActions className="actions-container">
        <FolderDetailSearchActions
          onCancel={handleReset}
          onSearch={handleSearch}
          onSelectCurrentJacket={handleSelectCurrentJacket}
          onCreateNewJacket={onCreateNewJacket}
          isDisabledCurrentJacket={isDisabledCurrentJacket}
        />
      </StyledActions>

      <FolderDetailSearchForm ref={searchFormRef} isFilterGrayBg={true} />

      <div style={{ padding: "20px" }}>
        <FolderFullDetails
          onFolderSelected={handleFolderSelected}
          selectedFolderTemp={selectedFolder}
          associates={true}
        />
      </div>
    </Modal>
  );
};

export default FolderDetailSearchModal;
